// 授标形式
const enums = {
  sbxingshi: {
    1: '总价',
    2: '明细',
    3: '入围',
    4: '费率',
  },
  // fenLei:{
  //   0:"工程",
  //   1:"货物",
  //   2:"服务",
  //   11:"主线土建工程",
  //   12:"机电工程",
  //   13:"小区房间工程",
  //   14:"养护工程",
  //   0:"工程",
  //   0:"工程",
  //   0:"工程",
  //   0:"工程",
  //   0:"工程",
  //   0:"工程",
  //   0:"工程",
  //   0:"工程",
  //   0:"工程",
  //   0:"工程",
  // }
}

function getValue(enumKey, key) {
  return enums[enumKey] && enums[enumKey][key]
}

export { enums, getValue }
